import * as React from 'react'
import { Form, InjectedFormProps } from 'redux-form'
import { VoiceCreateScriptStep } from '../VoiceCreateScriptStep'
import { VoiceCreateActorStep } from '../VoiceCreateActorStep'
import { VoiceCreateQuoteStep } from '../VoiceCreateQuoteStep'
import BillingAccountLinkStep from 'features/Billing/BillingAccountLinkStep'
import { Dots, Dot } from 'components/Dots'
import * as sMarg from 'styles/modules/margins.scss'
import { dispatchToProps } from './VoiceCreateForm.container'
import { IVoice } from '../types'
import { keyValArrayToObject } from '../../../utils/lodash'

export interface IVoiceCreateFormComponentProps extends InjectedFormProps<IVoice> {
  isLoggedIn: boolean
  push: typeof dispatchToProps['push']
  createVoice: typeof dispatchToProps['createVoice']
  onCancel: () => undefined
  noTalentSelection?: boolean
  formData: {
    step: number
  }
}

export class VoiceCreateFormComponent extends React.Component<IVoiceCreateFormComponentProps> {
  steps: any
  componentWillMount() {
    const { change, noTalentSelection } = this.props
    change('step', 0)

    this.steps = [
      ...(!noTalentSelection
        ? [
            {
              wrapInForm: true,
              Component: props => <VoiceCreateActorStep prev={props.onCancel} {...props} />,
            },
          ]
        : []),
      {
        wrapInForm: true,
        Component: props => (
          <VoiceCreateScriptStep
            prev={noTalentSelection ? props.onCancel : this.prevStep}
            {...props}
          />
        ),
      },
      {
        wrapInForm: true,
        Component: props => (
          <BillingAccountLinkStep
            prev={this.prevStep}
            {...props}
            headings={{
              heading: 'The part we love because you pay us!',
              subHeading:
                'Tell us where you would like to have your new voice recordings billed; this can be your existing Pickle Account or set up a New Billing Account below.',
            }}
          />
        ),
      },
      {
        wrapInForm: true,
        Component: props => <VoiceCreateQuoteStep prev={this.prevStep} {...props} />,
      },
    ]
  }
  submit = formData => {
    const {
      createVoice,
      push,
      formData: { step },
      reset,
      onCancel,
    } = this.props
    if (step === this.steps.length - 1) {
      return createVoice({
        title: formData.title,
        script: keyValArrayToObject(formData.script) as any,
        ban: formData.ban,
        talentID: formData.talentID,
      }).then(response => {
        reset()
        push(`/dashboard/voice-actor-recordings/${response.value.data.id}`)
        onCancel()
      })
    }
    this.nextStep()
  }

  nextStep = () => this.props.change('step', this.props.formData.step + 1)

  prevStep = () => this.props.change('step', this.props.formData.step - 1)

  render() {
    const { handleSubmit, formData } = this.props
    const step = this.steps[formData.step]
    if (step === undefined) {
      return null
    }

    return (
      <div>
        <Dots className={sMarg.mb60to30}>
          {this.steps.map((Step, idx) => (
            <Dot key={idx} active={formData.step === idx} />
          ))}
        </Dots>
        {step.wrapInForm ? (
          <Form onSubmit={handleSubmit(this.submit)}>
            <step.Component {...this.props} />
          </Form>
        ) : (
          <step.Component {...this.props} />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Voices/VoiceCreateForm/VoiceCreateForm.tsx